<template>
    <div>
        <form method="post" action="/fields" @submit.prevent="onSubmit">
            <label>Inserir Área de Atuação</label>
            <div class="form-group flex-row">
                <input type="text"
                       class="form-control"
                       v-model="form.name"
                >
                <button class="btn btn-md btn-primary m-l">Inserir</button>
            </div>
        </form>
        <label>Áreas de Atuação Cadastradas</label>
        <ul class="regioesAtuacao">
            <li v-for="field in fields" :key="field.id">
                {{ field.name }}
                <span class="btn-exclude"
                        @click="removeField(field)"
                >X</span>
            </li>
        </ul>
    </div>
</template>

<script>
import Form from 'form-backend-validation';

export default {
  data() {
      return {
          fields: [],
          form: new Form({
              name: null,
          }),
      };
  },
  created() {
      this.loadFields();
  },
  methods: {
      onSubmit() {
          this.form.post('/fields')
            .then(() => {
                this.loadFields();
                toastr.success('Área de atuação inserida com sucesso');
            }).catch(() => {
                toastr.error('Erro ao inserir área de atuação');
            });
      },
      loadFields() {
          axios.get('/fields')
            .then(({data}) => {
                this.fields = data;
            }).catch(() => {
                toastr.error('Erro ao carregar áreas de atuação');
            });
      },
      removeField(field) {
          axios.delete(`/fields/${field.id}`)
            .then(() => {
                toastr.success('Área de Atuação removida com sucesso');
                this.loadFields();
            }).catch(() => {
                toastr.error('Erro ao remover área de atuação');
            });
      }
  }
}
</script>
